import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { AppProvider } from './context/AppContext'
import { config } from './config'
import App from './App'

const msalConfig = {
  auth: {
    clientId: config?.clientId ?? '',
    authority: config?.clientAuthority ?? '',
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
}

const page = {
  IncidentsPage: null,
  DraftsPage: null,
  EnforcementContactsPage: null
}

const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Router>
    <MsalProvider instance={msalInstance}>
      <AppProvider
        apiScope={config?.scope ?? ''}
        apiBaseUrl={config?.apiBaseUrl ?? ''}
        page={page}
        sessionReset={false}
      >
        <App />
      </AppProvider>
    </MsalProvider>
  </Router>
)
